import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { FaCalculator, FaEraser } from 'react-icons/fa';
import CurrencyInput from 'react-currency-input';

export default function FormularioSimulacao(props) {
  var modoSimulacao = props.modoSimulacao;
  var setModoSimulacao = props.setModoSimulacao;
  var entradaCliente = props.entradaCliente;
  var setEntradaCliente = props.setEntradaCliente;
  var qtdParcelas = props.qtdParcelas;
  var setQtdParcelas = props.setQtdParcelas;
  var valorParcela = props.valorParcela;
  var setValorParcela = props.setValorParcela;
  var onSimular = props.onSimular;
  var onLimpar = props.onLimpar;
  var isSAC = props.isSAC;
  var isLoading = props.isLoading;

  var handleSubmit = function(e) {
    e.preventDefault();
    onSimular();
  };

  return (
        <Form onSubmit={handleSubmit}>
          <Row className="mb-2 align-items-center">
            <Col>
              <Form.Label className="mr-3 mb-0">
                <strong>Calcular:</strong>
              </Form.Label>
              <Form.Check
                inline
                type="radio"
                label="Valor da Parcela"
                name="modoSimulacao"
                id="modoV"
                checked={modoSimulacao === 'V'}
                onChange={function() {
                  setModoSimulacao('V');
                }}
              />
              <Form.Check
                inline
                type="radio"
                label={isSAC ? 'Qtd. Aproximada' : 'Qtd. Parcelas'}
                name="modoSimulacao"
                id="modoQ"
                checked={modoSimulacao === 'Q'}
                onChange={function() {
                  setModoSimulacao('Q');
                }}
              />
              {!isSAC && (
                <Form.Check
                  inline
                  type="radio"
                  label="Entrada"
                  name="modoSimulacao"
                  id="modoE"
                  checked={modoSimulacao === 'E'}
                  onChange={function() {
                    setModoSimulacao('E');
                  }}
                />
              )}
            </Col>
          </Row>

          <Row>
            {modoSimulacao !== 'E' && (
              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="small mb-1">Entrada</Form.Label>
                  <CurrencyInput
                    className="form-control form-control-sm"
                    value={entradaCliente}
                    decimalSeparator=","
                    thousandSeparator="."
                    prefix="R$ "
                    onChangeEvent={function(e, maskedvalue, floatvalue) {
                      setEntradaCliente(floatvalue);
                    }}
                  />
                </Form.Group>
              </Col>
            )}

            {modoSimulacao !== 'Q' && (
              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="small mb-1">Qtd. Parcelas</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    min="1"
                    max="9999"
                    required
                    value={qtdParcelas}
                    onChange={function(e) {
                      setQtdParcelas(e.target.value);
                    }}
                  />
                </Form.Group>
              </Col>
            )}

            {modoSimulacao !== 'V' && (
              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="small mb-1">
                    {isSAC ? 'Valor da 1ª Parcela' : 'Valor da Parcela'}
                  </Form.Label>
                  <CurrencyInput
                    className="form-control form-control-sm"
                    value={valorParcela}
                    decimalSeparator=","
                    thousandSeparator="."
                    prefix="R$ "
                    onChangeEvent={function(e, maskedvalue, floatvalue) {
                      setValorParcela(floatvalue);
                    }}
                  />
                </Form.Group>
              </Col>
            )}
          </Row>

          <Row>
            <Col>
              <Button
                type="submit"
                size="sm"
                variant="primary"
                disabled={isLoading}
                className="mr-2"
              >
                <FaCalculator className="mr-1" />
                Simular
              </Button>
              <Button
                size="sm"
                variant="outline-secondary"
                onClick={onLimpar}
              >
                <FaEraser className="mr-1" />
                Nova Simulação
              </Button>
            </Col>
          </Row>
        </Form>
  );
}
